.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  align-items: center;
}

.row {
  display: flex;
  gap: var(--tuna-spacing-1);
  align-items: center;
}

.rowLabel {
  min-width: 64px;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
}

.btn {
  min-width: 44px;
}
